import type { ISeatStatus } from "../../../../Domain/Types/FloorPlan/SeatStatus.type";

/**
 * Hover copy when the inventory is tandem-blocked (unavailable to book).
 * Place vs room wording; richer partner who/when can be added later.
 */
export function tandemBlockedHoverLabel(
  inventoryId: number | undefined,
  seatStatus: ISeatStatus,
  kind: "place" | "zone",
  t: (key: string) => string
): string | undefined {
  if (inventoryId == null) {
    return undefined;
  }
  if (!(seatStatus.blockedList?.includes(inventoryId) ?? false)) {
    return undefined;
  }
  return kind === "zone" ? t("_tandemBlocked_zoneHover") : t("_tandemBlocked_placeHover");
}
